import { render, staticRenderFns } from "./TranscriptionToolbar.vue?vue&type=template&id=135b0cd9&"
import script from "./TranscriptionToolbar.vue?vue&type=script&lang=js&"
export * from "./TranscriptionToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports